var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAtom = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.67 11.342C2.93 10.954 2.5 10.494 2.5 10c0-1.38 3.358-2.5 7.5-2.5 4.142 0 7.5 1.12 7.5 2.5 0 .595-.624 1.142-1.667 1.572M10 9.175l.008-.01"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.07 5c-.005-.852-.22-1.456-.665-1.683-1.23-.626-3.752 1.857-5.633 5.548-1.88 3.69-2.407 7.19-1.177 7.818.44.223 1.044.05 1.725-.433"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.001 3.543c-.55-.322-1.036-.414-1.406-.226-1.23.627-.703 4.127 1.177 7.818 1.881 3.69 4.403 6.174 5.633 5.548 1.093-.558.799-3.385-.601-6.598"
}))));
export default SvgAtom;